import { render, staticRenderFns } from "./AppAgreement.vue?vue&type=template&id=91830c0c"
import script from "./AppAgreement.vue?vue&type=script&lang=js"
export * from "./AppAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports